const common = {
    en: {
        common: {
            save: 'Save',
            cancel: 'Cancel',
            close: 'Close',
            delete: 'Delete',
            edit: 'Edit',
            confirm: 'Confirm',
            search: 'Search',
            loading: 'Loading...',
            back: 'Back',
            appName: 'GemiTrans',
            copy: 'Copy',
            copied: 'Copied',
            all: 'All',
            noResults: 'No results',
        },
    },
    th: {
        common: {
            save: 'บันทึก',
            cancel: 'ยกเลิก',
            close: 'ปิด',
            delete: 'ลบ',
            edit: 'แก้ไข',
            confirm: 'ยืนยัน',
            search: 'ค้นหา',
            loading: 'กำลังโหลด...',
            back: 'ย้อนกลับ',
            appName: 'GemiTrans',
            copy: 'คัดลอก',
            copied: 'คัดลอกแล้ว',
            all: 'ทั้งหมด',
            noResults: 'ไม่พบผลลัพธ์',
        },
    },
};

export default common;
